import { CalendarTwoTone, StarFilled, UserOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import moment from "moment";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faEye, faClockRotateLeft, faTrashCan } from '@fortawesome/free-solid-svg-icons';

const colorSchemes = [
    { bg: "bg-pink-100", text: "text-pink-800", border: "border-pink-500" },
    { bg: "bg-teal-100", text: "text-teal-800", border: "border-teal-500" },
    { bg: "bg-green-100", text: "text-green-800", border: "border-green-500" },
    { bg: "bg-yellow-100", text: "text-yellow-800", border: "border-yellow-500" },
];

const TagPreview = ({ tagName, businessAreaName, tagDescription }) => {
    const { bg, text, border } = colorSchemes[0];

    return (
        <div className="group relative flex flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow-md transition-shadow duration-300 ease-in-out hover:shadow-xl">
            <div className="absolute -right-8 top-4 rotate-45 bg-blue-500 px-8 py-1 text-xs font-semibold text-white shadow-sm">Preview</div>
            <div className="flex items-center justify-between rounded-t-lg bg-blue-100 p-3">
                <div className="flex flex-row items-center">
                    <h3 className="text-lg font-bold text-blue-600">{tagName || "Tag Name"}</h3>
                    <span className={`mx-2 mt-1 rounded-full px-2 py-1 text-xs font-medium ${bg} ${text} border ${border}`}>{businessAreaName || "business area"}</span>
                </div>
                <div className="mr-12 flex space-x-1">
                    <Tooltip title="Preview Star">
                        <StarFilled className="cursor-pointer text-xl text-gray-400 hover:text-yellow-500" />
                    </Tooltip>
                </div>
            </div>
            <div className="flex-grow overflow-hidden p-4 hover:bg-slate-100">
                <Tooltip title={tagDescription} placement="bottomLeft" classNames={{ root: "max-w-md" }}>
                    <div className="mb-4 line-clamp-3 text-lg font-light text-gray-800 hover:text-clip">{tagDescription || "Tag description will appear here"}</div>
                </Tooltip>
                <div className="flex flex-col items-start rounded-md text-base text-gray-500">
                    <div className="flex items-center gap-2 text-base font-medium">
                        <CalendarTwoTone className="text-2xl text-blue-500" />
                        <span>{moment().toDate().toLocaleString()}</span>
                    </div>
                    <div className="flex items-center gap-2 text-base font-semibold">
                        <UserOutlined className="text-2xl text-green-500" />
                        <span>user@example.com</span>
                    </div>
                </div>
            </div>
            <div className="flex items-center justify-between border-t border-gray-200 p-4">
                <div className="flex space-x-2">
                    <Button icon={<FontAwesomeIcon icon={faPencil} className="text-blue-500" />} disabled />
                    <Button icon={<FontAwesomeIcon icon={faEye} className="text-blue-500" />} disabled />
                    <Button icon={<FontAwesomeIcon icon={faClockRotateLeft} className="text-blue-500" />} disabled />
                    <Button icon={<FontAwesomeIcon icon={faTrashCan} className="text-blue-500" />} disabled />
                </div>
            </div>
        </div>
    );
};

export default TagPreview;
